import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Info from '@/components/Info'
import Home from "../components/Home";
import StudyIndex from "../components/StudyIndex";
import ArticleDetailsPage from "../components/hpage/ArticleDetailsPage";
import HomeArticleDetails from "../components/articles/HomeArticleDetails";
import Test from "../components/common/Test";
import Login from "../components/common/Login";
import {getUserInfo,getUserToken} from "../utils/UserUtil";
import {userInfo} from "../utils/Config";
import UserInfo from "../components/user/UserInfo";
import userLogin from "../components/user/userLogin";
import SimpleClickEvent from '@/components/common/SimpleClickEvent'

Vue.use(Router)

//export default new Router({
const router = new Router({
  routes: [
    {
      path:'/',
      name:'home',
      component:Home
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/userLogin',
      name: 'userLogin',
      component: userLogin
    },
    {
      path: '/UserInfo',
      name: 'UserInfo',
      component: UserInfo
    },
    {
      path: '/study',
      name: 'Study',
      component: StudyIndex
    },
    {
      path: '/article/details',
      name: 'HomeArticleDetails',
      component: HomeArticleDetails
    },
    {
      path: '/article',
      name: 'Article',
      component: ArticleDetailsPage
    },
    {
      path: '/hello_world',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/test',
      name: 'Test',
      component: Test
    },
    {
      path: '/test2',
      name: 'SimpleClickEvent',
      component: SimpleClickEvent
    },
    {
      path: '/info',
      name: 'Info',
      component: Info
    }
  ]
});

router.beforeEach((to, from, next) => {
  this.userInfo = getUserInfo();
  let userToken = getUserToken();
  let route = this.$router;
  console.log(this.$router);
  debugger;
  // 这个要了解下
  if ((this.userInfo && this.userInfo.username && userToken) || (this.$router && to.name === this.$router[1].name)){
    debugger;
    console.log("router1");
    next()
  } else {
    debugger;
    console.log("router2");
    next()
  }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js